<template>
  <div v-if="loadingStatus" class="body-max-width-background-color">
    <Header title=""></Header>
    <!-- <div class="flex-mid pt-40">
      <div class="fs-18 fc-000000 pt-40">
        <div class="pt-40 center">
          <img
            src="@/assets/image/PackageForYou/loading-dots-blue.gif"
            alt=""
            class="mx-auto"
            style="
              width: 100%;
              max-width: 19rem;
              height: 100%;
              margin-bottom: 0px;
              object-fit: scale-down;
            "
          />
        </div>
        <div class="center">{{ $t("loading") }}</div>
      </div>
    </div> -->
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              /* margin-right: -10px; */
              /* max-width: 25rem; */
              /* left:-20px; */
              height: 120%;
              /* margin-bottom: 0px; */
              object-fit: cover;
              overflow: hidden;
              /* object-position: 30% 10%; */
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>
  <div v-else class="body-max-width-background-color">
    <div class="relative body-max-width-no-padding" style="overflow: hidden">
      <img
        src="@/assets/image/Home/banner_total.png"
        alt="alexandr"
        class="bg-image-header"
      />
      <div class="home body-max-width">
        <Header title=""></Header>
        <div class="header" style="">
          <!-- <div class="fs-22 mt-36">{{ $t("hello") }}</div> -->
          <!-- <div class="fs-30">{{ name }}</div> -->
          <div
            @click="redirect('?coin')"
            class="coin-container flex-center mb-40"
          >
            <div class="value flex-center">
              <div class="text">{{ coinPattern(coin) }} Coins</div>
            </div>
            <div class="icon flex-mid">
              <!-- <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.999 18.515C36.9978 28.7701 28.7316 37.004 18.4426 37C8.22966 36.9961 -0.00797931 28.7136 5.80033e-06 18.4571C0.00780376 8.21092 8.28575 -0.0109688 18.5843 1.09843e-05C28.7644 0.00975867 37.001 8.29067 37 18.516L36.999 18.515ZM8.70078 18.5754C12.8618 21.0354 15.9092 24.5539 18.6494 28.4124C20.9366 24.1176 24.6417 21.3165 28.4214 18.554C24.1895 16.16 21.2481 12.5623 18.5433 8.66194C15.807 12.5196 12.9046 16.1358 8.70078 18.5754Z"
                  fill="#D9C36E"
                />
              </svg> -->
              <img
                src="@/assets/image/Home/coin2.png"
                alt="coin"
                style="width: 50px; height: 50px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-2">
      <div class="home body-max-width-background-color">
        <!-- if TESTED show code from here -->
        <div v-if="!haveRisk" class="">
          <div class="get-risk-container body-max-width">
            <div class="image flex-mid">
              <img
                src="@/assets/image/Home/moderate-01.png"
                alt=""
                style="width: 11rem; height: 9rem"
              />
            </div>
            <div class="content center fw-400">
              <div class="fs-16">{{ $t("getRiskTitle") }}</div>
              <div class="fs-14 fc-7E7E7E mt-4">{{ $t("getRiskDesc1") }}</div>
              <div class="fs-14 fc-7E7E7E">{{ $t("getRiskDesc2") }}</div>
              <div
                id="goToQuestionaire"
                @click="goToQuestionaire"
                class="btn btn-take-test mt-12 mx-auto"
              >
                {{ $t("getRiskButton") }}
              </div>
            </div>
          </div>

          <div class="background-green">
            <div class="body-max-width">
              <div style="z-index: 1">
                <div class="flex-center">
                  <div
                    style="
                      margin-right: 1rem;
                      margin-left: 1rem;
                      margin-top: 1.5rem;
                    "
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="16" cy="16" r="16" fill="#429928" />
                      <path
                        d="M12.75 23H10.5C10.1022 23 9.72064 22.842 9.43934 22.5607C9.15804 22.2794 9 21.8978 9 21.5V16.25C9 15.8522 9.15804 15.4706 9.43934 15.1893C9.72064 14.908 10.1022 14.75 10.5 14.75H12.75M18 13.25V10.25C18 9.65326 17.7629 9.08097 17.341 8.65901C16.919 8.23705 16.3467 8 15.75 8L12.75 14.75V23H21.21C21.5717 23.0041 21.9228 22.8773 22.1984 22.643C22.4741 22.4087 22.6558 22.0827 22.71 21.725L23.745 14.975C23.7776 14.76 23.7631 14.5405 23.7025 14.3317C23.6419 14.1229 23.5366 13.9297 23.3939 13.7656C23.2512 13.6016 23.0746 13.4704 22.8762 13.3814C22.6778 13.2924 22.4624 13.2475 22.245 13.25H18Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="fs-18 fw-500" style="margin-top: 1.5rem">
                    {{ $t("healthPackage") }}
                  </div>
                  <div
                    @click="$router.push('/health-package')"
                    class="see-all-link ml-auto"
                    id="seeAllPackages"
                  >
                    {{ $t("seeAll") }}
                  </div>
                </div>

                <div class="body-max-width fs-12 mt-10">
                  {{ $t("forThai") }}
                </div>
                <!-- <div class="searching-package mt-20">
            <div class="search-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12.9056 14.3199C11.551 15.3729 9.84871 16 8 16C3.58172 16 0 12.4183 0 8Z"
                  fill="#3F3F3F" />
              </svg>
            </div>
            <input :placeholder="$t('search')" v-model="searchPagkage" class="input-style" type="text" />
          </div> -->
                <div class="mt-10 hospital-input" style="width: 100%">
                  <el-select
                    class="white-home"
                    id="selectHospital"
                    v-model="selectHospital"
                    :placeholder="$t('choosehospital')"
                    @change="getPackage()"
                  >
                    <el-option :label="$t('sukhumvit')" value="1"> </el-option>
                    <el-option :label="$t('srinakarin')" value="2"> </el-option>
                    <el-option :label="$t('thonburi')" value="4"> </el-option>
                    <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
        <el-option :label="$t('chonburi')" value="5"> </el-option>
        <el-option :label="$t('chinatown')" value="6"> </el-option> -->
                  </el-select>
                </div>
                <div
                  v-if="packageList.length == 0"
                  style="
                    text-align: center;
                    font-size: 2rem;
                    padding-top: 10rem;
                  "
                >
                  {{ $t("notFound") }}
                </div>
                <swiper
                  :slides-per-view="1.9"
                  :space-between="10"
                  :mousewheel="true"
                  :virtualIndex="2"
                  :pagination="{
                    dynamicBullets: true,
                  }"
                  :breakpoints="{
                    '333': {
                      slidesPerView: 2.0,
                      spaceBetween: 10,
                    },
                    '360': {
                      slidesPerView: 2.1,
                      spaceBetween: 10,
                    },
                    '400': {
                      slidesPerView: 2.3,
                      spaceBetween: 10,
                    },
                    '500': {
                      slidesPerView: 2.5,
                      spaceBetween: 10,
                    },
                    '600': {
                      slidesPerView: 2.7,
                      spaceBetween: 10,
                    },
                    '620': {
                      slidesPerView: 2.8,
                      spaceBetween: 10,
                    },
                  }"
                  style="padding: 1rem 1.5rem 4rem"
                >
                  <swiper-slide v-for="value in packageList" :key="value.id">
                    <router-link
                      :to="{
                        path: '/package-select',
                        query: {
                          packageId: value.packageId,
                          hospitalId: value.hospitalId,
                        },
                      }"
                    >
                      <div class="package-card" id="packageCard">
                        <div class="content">
                          <img
                            class="image"
                            :src="value.imageUrl"
                            :alt="value.title"
                          />
                          <div class="text">
                            <div class="">{{ value.packageName }}</div>
                            <!-- <div class="mt-1 fs-10">
                        {{ value.packageDescription }}
                      </div> -->
                            <!-- <div class="mt-1 fs-10 uppercase">
                        <div>✚ {{ value.hospitalName }}</div> -->
                            <!-- <div v-for="val in value.hopitalAvalible" :key="val.id">
                      ✚ {{ val.name }}
                    </div> -->
                            <!-- </div> -->
                          </div>
                          <div class="price">
                            <div v-if="value.netPrice == value.listPrice">
                              <div class="price-net-2">
                                {{ value.netPrice }}
                              </div>
                            </div>
                            <div v-else>
                              <div class="price-net">{{ value.netPrice }}</div>
                              <div class="price-list">
                                {{ value.listPrice }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </swiper-slide>
                </swiper>
                <!-- <div class="package-card-container mt-20">
            <div v-for="value in packageList" :key="value.id" class="package-card">
              <router-link :to="{
                path: '/package-select',
                query: {
                  packageId: value.packageId,
                  hospitalId: value.hospitalId,
                },
              }">
                <img class="image" style="width:2rem;" :src="value.imageUrl" :alt="value.packageName" />
                <div class="content">
                  <div class="text">
                    <div class="fs-14 fw-700">{{ value.packageName }}</div>
           
                    <div class="mt-1 fs-10 uppercase">
             
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="center m-40 p-40">---- else on here ----</div> -->
        <!-- else have not test -->
        <div v-else>
          <div
            class="flex-center mt-30 body-max-width"
            style="padding: 0rem 2rem 0rem"
          >
            <div class="fs-18 fw-500">{{ $t("riskScore") }}</div>
            <div class="ml-auto fc-8C8C8C flex-mid">
              <svg
                width="12"
                height="18"
                viewBox="0 0 12 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 3.86937V6.19098L9 3.09549L6 0V2.32162C2.685 2.32162 0 5.09208 0 8.5126C0 9.72758 0.345 10.8574 0.93 11.8093L2.025 10.6794C1.6875 10.0371 1.5 9.29422 1.5 8.5126C1.5 5.95108 3.5175 3.86937 6 3.86937ZM11.07 5.2159L9.975 6.34576C10.305 6.99581 10.5 7.73099 10.5 8.5126C10.5 11.0741 8.4825 13.1558 6 13.1558V10.8342L3 13.9297L6 17.0252V14.7036C9.315 14.7036 12 11.9331 12 8.5126C12 7.29762 11.655 6.16777 11.07 5.2159Z"
                  fill="#8C8C8C"
                />
              </svg>
              <span @click="testAgain" class="ml-2 cursor-pointer fs-14">{{
                $t("testAgain")
              }}</span>
            </div>
          </div>
          <div>
            <div v-if="riskScoreList.length == 0" class="no-suggest-package">
              <div class="text p-10">
                <div class="center">
                  <div class="mt-10">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_12811_16937)">
                        <path
                          d="M25 42C36.598 42 46 32.598 46 21C46 9.40202 36.598 0 25 0C13.402 0 4 9.40202 4 21C4 32.598 13.402 42 25 42Z"
                          fill="white"
                        />
                        <path
                          d="M24.9995 38.9492C34.9128 38.9492 42.9492 30.9128 42.9492 20.9995C42.9492 11.0862 34.9128 3.0498 24.9995 3.0498C15.0862 3.0498 7.0498 11.0862 7.0498 20.9995C7.0498 30.9128 15.0862 38.9492 24.9995 38.9492Z"
                          fill="#89C980"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.1486 22.4803C19.2989 22.3016 19.5206 22.1984 19.7542 22.1984H31.0177C31.2451 22.1984 31.4615 22.2962 31.6117 22.4669C31.7619 22.6376 31.8315 22.8647 31.8026 23.0902L31.0177 22.9896C31.8026 23.0902 31.8025 23.0908 31.8024 23.0913L31.8023 23.0925L31.8019 23.0951L31.8011 23.1013L31.7986 23.1182C31.7967 23.1313 31.794 23.1482 31.7905 23.1685C31.7834 23.2092 31.7729 23.2638 31.7579 23.3306C31.7279 23.4638 31.6794 23.6463 31.6031 23.8617C31.4508 24.2913 31.1842 24.861 30.724 25.4311C29.7794 26.6013 28.1019 27.6699 25.2376 27.6699V26.8787C25.2376 27.6699 25.2372 27.6699 25.2369 27.6699L25.2361 27.6699L25.2342 27.6699L25.229 27.6699L25.2135 27.6697C25.2008 27.6696 25.1836 27.6693 25.1622 27.6687C25.1193 27.6675 25.0594 27.6653 24.9845 27.661C24.835 27.6525 24.625 27.6356 24.3726 27.6024C23.8707 27.5363 23.1858 27.4033 22.4698 27.1327C21.0366 26.591 19.3787 25.4481 18.9746 23.1252C18.9346 22.8951 18.9983 22.6591 19.1486 22.4803Z"
                          fill="#592727"
                        />
                        <path
                          d="M16.7665 19.0894C17.658 19.0894 18.3807 18.3667 18.3807 17.4753C18.3807 16.5838 17.658 15.8611 16.7665 15.8611C15.875 15.8611 15.1523 16.5838 15.1523 17.4753C15.1523 18.3667 15.875 19.0894 16.7665 19.0894Z"
                          fill="#592727"
                        />
                        <path
                          d="M33.2489 19.0894C34.1404 19.0894 34.8631 18.3667 34.8631 17.4753C34.8631 16.5838 34.1404 15.8611 33.2489 15.8611C32.3575 15.8611 31.6348 16.5838 31.6348 17.4753C31.6348 18.3667 32.3575 19.0894 33.2489 19.0894Z"
                          fill="#592727"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_12811_16937"
                          x="0"
                          y="0"
                          width="50"
                          height="50"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_12811_16937"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_12811_16937"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <div class="fs-14 fw-500">{{ $t("noRisk") }}</div>
                </div>
                <div></div>
                <p class="fs-12 fw-500">{{ $t("suggest") }}</p>

                <div
                  v-if="!showNoRisk"
                  class="fs-11"
                  v-html="$t('nothaverisksuggest')"
                ></div>
                <div
                  v-else
                  class="fs-11"
                  v-html="$t('nothaverisksuggest2')"
                ></div>
              </div>

              <div class="">
                <div @click="showNoRisk = !showNoRisk" class="footer flex-mid">
                  <span :class="`${showNoRisk ? 'rotate' : ''}`">
                    <svg
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                v-for="value in riskScoreList"
                :key="value.riskId"
                :class="`suggest-package ${value.showStatus ? 'show' : ''}`"
              >
                <div :class="`risk-status ${value.status} flex-mid`">
                  {{ value.severityName }}
                </div>
                <div class="body">
                  <div class="blur-text"></div>
                  <div :class="`hidden-content`">
                    <div class="icon center">
                      <div class="mt-16">
                        <img
                          v-if="value.riskId == 1"
                          src="../assets/image/Disease/cardiovascular-pic.png"
                          style="width: 6rem"
                        />
                        <img
                          v-else-if="value.riskId == 2"
                          src="../assets/image/Disease/diabetes-pic.png"
                          style="width: 6rem"
                        />
                        <img
                          v-else-if="value.riskId == 3"
                          src="../assets/image/Disease/cancer-pic.png"
                          style="width: 6rem"
                        />
                        <img
                          v-else-if="value.riskId == 4"
                          src="../assets/image/Disease/stroke-pic.png"
                          style="width: 6rem"
                        />
                        <img
                          v-else-if="value.riskId == 5"
                          src="../assets/image/Disease/metabolic-pic.png"
                          style="width: 6rem"
                        />
                        <img
                          v-else-if="value.riskId == 6"
                          src="../assets/image/Disease/lung-cancer.png"
                          style="width: 6rem"
                        />
                      </div>
                      <div class="label" style="margin: auto">
                        {{ value.riskName }}
                      </div>
                    </div>
                    <div class="relative">
                      <div class="fs-14 fw-500 mt-10">{{ $t("suggest") }}</div>
                      <!-- <div class="fs-12 mt-7 fc-9C9C9C">
                    &nbsp;&nbsp;&nbsp;&nbsp;แนะนำให้คุณเข้ารับคำปรึกษาจากแพทย์ในเบื้องต้น
                  </div> -->
                      <ul class="hidden-des">
                        <li
                          class=""
                          v-for="(val, i) in value.suggest"
                          :key="i + '_' + value.id"
                        >
                          {{ val }}
                        </li>
                      </ul>
                      <div class="suggest-note">{{ value.note }}</div>
                    </div>
                  </div>
                </div>
                <div
                  @click="value.showStatus = !value.showStatus"
                  class="footer flex-mid"
                >
                  <span :class="`${value.showStatus ? 'rotate' : ''}`">
                    <svg
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div
                v-if="riskScoreList.length < 3"
                style="margin: auto; width: 90%; font-size: 1.4rem"
              >
                {{ $t("suggestedisease2") }}
              </div>
            </div>
          </div>
          <div>
            <div
              id="buttonYourHealthPackage"
              @click="$router.push('/package-for-you')"
              class="btn-60 btn-primary btn mx-auto mt-22"
              style="width: 29rem"
            >
              {{ $t("yourPersonalizePackage") }}
            </div>
          </div>

          <div class="background-green">
            <div class="body-max-width">
              <div class="flex-center mt-30" style="padding-top: 2rem">
                <div style="margin-right: 1rem; margin-left: 1rem">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="16" cy="16" r="16" fill="#429928" />
                    <path
                      d="M12.75 23H10.5C10.1022 23 9.72064 22.842 9.43934 22.5607C9.15804 22.2794 9 21.8978 9 21.5V16.25C9 15.8522 9.15804 15.4706 9.43934 15.1893C9.72064 14.908 10.1022 14.75 10.5 14.75H12.75M18 13.25V10.25C18 9.65326 17.7629 9.08097 17.341 8.65901C16.919 8.23705 16.3467 8 15.75 8L12.75 14.75V23H21.21C21.5717 23.0041 21.9228 22.8773 22.1984 22.643C22.4741 22.4087 22.6558 22.0827 22.71 21.725L23.745 14.975C23.7776 14.76 23.7631 14.5405 23.7025 14.3317C23.6419 14.1229 23.5366 13.9297 23.3939 13.7656C23.2512 13.6016 23.0746 13.4704 22.8762 13.3814C22.6778 13.2924 22.4624 13.2475 22.245 13.25H18Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="fs-18 fw-500">{{ $t("healthPackage") }}</div>
                <div
                  @click="$router.push('/health-package')"
                  class="see-all-link ml-auto"
                >
                  {{ $t("seeAll") }}
                </div>
              </div>

              <div class="body-max-width fs-12 mt-10">{{ $t("forThai") }}</div>

              <div class="filterHospital">
                <div style="font-size: 1.6rem; margin-left: 2rem">
                  {{ $t("choosehospital") }}
                </div>

                <!-- <div class="hospital-input"> -->
                <el-select
                  class="mt-10 hospital-input white-home"
                  id="selectHospital"
                  v-model="selectHospital"
                  :placeholder="$t('choosehospital')"
                  @change="getPackage()"
                >
                  <el-option :label="$t('sukhumvit')" value="1"> </el-option>
                  <el-option :label="$t('srinakarin')" value="2"> </el-option>
                  <el-option :label="$t('thonburi')" value="4"> </el-option>
                  <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
        <el-option :label="$t('chonburi')" value="5"> </el-option>
        <el-option :label="$t('chinatown')" value="6"> </el-option> -->
                </el-select>
              </div>

              <swiper
                :slides-per-view="1.9"
                :space-between="10"
                :mousewheel="true"
                :virtualIndex="2"
                :pagination="{
                  dynamicBullets: true,
                }"
                :breakpoints="{
                  '333': {
                    slidesPerView: 2.0,
                    spaceBetween: 10,
                  },
                  '360': {
                    slidesPerView: 2.1,
                    spaceBetween: 10,
                  },
                  '400': {
                    slidesPerView: 2.3,
                    spaceBetween: 10,
                  },
                  '500': {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                  },
                  '600': {
                    slidesPerView: 2.7,
                    spaceBetween: 10,
                  },
                  '620': {
                    slidesPerView: 2.8,
                    spaceBetween: 10,
                  },
                }"
                style="padding: 1rem 1.5rem 4rem"
              >
                <swiper-slide v-for="value in packageList" :key="value.id">
                  <router-link
                    :to="{
                      path: '/package-select',
                      query: {
                        packageId: value.packageId,
                        hospitalId: value.hospitalId,
                      },
                    }"
                  >
                    <div class="package-card">
                      <div class="content">
                        <img
                          class="image"
                          :src="value.imageUrl"
                          :alt="value.title"
                        />
                        <div class="text">
                          <div class="">{{ value.packageName }}</div>
                          <!-- <div class="mt-1 fs-10">
                        {{ value.packageDescription }}
                      </div> -->
                          <!-- <div class="mt-1 fs-10 uppercase">
                        <div>✚ {{ value.hospitalName }}</div> -->
                          <!-- <div v-for="val in value.hopitalAvalible" :key="val.id">
                      ✚ {{ val.name }}
                    </div> -->
                          <!-- </div> -->
                        </div>
                        <div class="price">
                          <div v-if="value.netPrice == value.listPrice">
                            <div class="price-net-2">
                              {{ numberWithCommasLine(value.netPrice) }}
                            </div>
                          </div>
                          <div v-else>
                            <div class="price-net">
                              {{ numberWithCommasLine(value.netPrice) }}
                            </div>
                            <div class="price-list">
                              {{ numberWithCommasLine(value.listPrice) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="border-radius: 30px">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              @click="redirect('?mainapp')"
              style="font-size: 40px; padding-right: 10px"
              >&times;</span
            >
          </button>
          <div style="text-align: center">
            <Vue3Lottie :animationData="errorImg" :speed="1" />

            <h3>Something went wrong</h3>
            <p style="font-size: 12px">
              please try again later or contact us +66(0) 2022 2222
            </p>
            Error : {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import { Mousewheel } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/autoplay/autoplay.scss";
import axios from "axios";
import * as config from "@/assets/js/config.js";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
SwiperCore.use([EffectCoverflow, Pagination]);
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import errorImg from "@/assets/image/36572-under-maintenance.json";

export default defineComponent({
  name: "Home",
  components: {
    Header,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Mousewheel],
    };
  },
  data() {
    return {
      errorImg,
      loadingStatus: true,
      channel: null,
      name: null,
      coin: 0,
      lang: "th",
      searchPagkage: "",
      accessToken: null,
      haveRisk: false,
      riskScoreList: [],
      showNoRisk: false,
      error: null,
      allPackageList: [],
      packageList: [],
      selectHospital: "1",
      packageHospital: [],
      list: [],
      username: "",
      memberId: "",
    };
  },
  mounted() {
    this.channel = this.$cookies.get("channel");
    this.lang = this.$cookies.get("lang");
    this.username = this.$cookies.get("username");
    this.memberId = this.$cookies.get("memberId");
    this.$gtag.config({
      user_id: this.username,
    });
    if (this.channel == null) {
      this.accessToken = this.$cookies.get("access_token");
      if (this.accessToken == null) {
        this.error = "Please Send Access Token";
        window.$("#errorModal").modal("show");
      }
    } else if (this.channel == "supperapp") {
      this.accessToken = this.$cookies.get("access_token");
      this.getData();
      this.getPackage();
      this.getDataHospital();
    } else if (this.channel == "plusV5") {
      this.accessToken = this.$cookies.get("access_token");
      if (this.accessToken == null) {
        let plusToken = this.$cookies.get("plus_access_token");
        this.getPlusDataV5(plusToken);
      } else {
        this.getData();
        this.getPackage();
        this.getDataHospital();
      }
    } else if (this.channel == "plus") {
      this.accessToken = this.$cookies.get("access_token");
      if (this.accessToken == null) {
        const urlParams = new URLSearchParams(window.location.search);
        let plusMemberId = urlParams.get("memberId");
        this.getPlusData(plusMemberId);
      } else {
        this.getData();
        this.getPackage();
        this.getDataHospital();
      }
    }
  },
  watch: {
    searchPagkage() {
      this.filterPackage();
    },
  },
  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    goToQuestionaire() {
      this.$gtag.event("click_questionaire_button", {
        event_category: "Home_page",
        event_label: "click questionaire button",
      });
      this.$router.push("/question");
    },
    testAgain() {
      this.$gtag.event("click_testagain_button", {
        event_category: "Home_page",
        event_label: "click test again button",
      });
      this.$router.push("/question");
    },
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    coinPattern(num) {
      if (num < 900) {
        return num; // if value < 1000, nothing to do
      } else if (num < 1000000) {
        return (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
      } else if (num < 1000000000) {
        return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
      } else {
        return (num / 1000000000).toFixed(1) + "B"; // convert to M for number from > 1 million
      }
    },
    getPlusData(memberId) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/datacenter/plus/get",
          {
            memberId: memberId,
          },
          {
            headers: {
              "Accept-Language": this.lang,
            },
          }
        )
        .then((response) => {
          let access = response.data;
          this.$cookies.set("access_token", access.data.idToken);
          this.$cookies.set("refresh_token", access.data.refreshToken);
          this.$cookies.set("username", access.data.username);
          // this.$cookies.set("channel", "supperapp");
          this.accessToken = access.data.idToken;
          this.getData();
          this.getPackage();
        })
        .catch((error) => {
          this.error = error.response.data.message;
          console.log(this.error);
          window.$("#errorModal").modal("show");
        });
    },
    getPlusDataV5(token) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/datacenter/plus/v5/get",
          {
            token: "Bearer " + token,
          },
          {
            headers: {
              "Accept-Language": this.lang,
            },
          }
        )
        .then((response) => {
          let access = response.data;
          this.$cookies.set("access_token", access.data.idToken);
          this.$cookies.set("refresh_token", access.data.refreshToken);
          this.$cookies.set("username", access.data.username);
          // this.$cookies.set("channel", "supperapp");
          this.accessToken = access.data.idToken;
          this.getData();
          this.getPackage();
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
    getData() {
      this.loadingStatus = true;
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          // console.log(res);
          if (res.coin != null) {
            this.coin = res.coin;
          }
          this.name = res.customer.firstName;
          if (res.riskAssessment.risks.length > 0) {
            let risks = [];
            this.haveRisk = true;
            for (let i = 0; i < res.riskAssessment.risks.length; i++) {
              let risk = res.riskAssessment.risks[i];
              if (risk.severity > 0) {
                risk["showStatus"] = false;
                risk["status"] =
                  risk.maxSeverityLevel == 2
                    ? risk.severity == 1
                      ? "low"
                      : "high"
                    : risk.severity == 1
                    ? "low"
                    : risk.severity == 2
                    ? "moderate"
                    : "high";

                // console.log("RiskRecommentdation", risk.riskRecommendation);
                if (risk.riskRecommendation.match(/\*.+/g)) {
                  risk["note"] = risk.riskRecommendation
                    .match(/\*.+/g)
                    .toString();
                  risk.riskRecommendation = risk.riskRecommendation.replace(
                    /\*.+/g,
                    ""
                  );
                } else {
                  risk["note"] = risk.riskRecommendation;
                }

                risk["suggest"] = risk.riskRecommendation
                  .replace(/^[ ]*-/g, "")
                  .split("\n-");
                risks.push(risk);
              }
            }
            risks.sort((a, b) => b.severity - a.severity);
            this.riskScoreList = risks;
          }

          // console.log("riskScoreList", this.riskScoreList);

          this.loadingStatus = false;
        })
        .catch((error) => {
          // this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            this.loadingStatus = false;
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    getPackage() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/checkup-package/get",
          {
            getCheckupPackageReqBean: {
              hospitalId: this.selectHospital,
              categoryId: null,
              keywords: null,
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          this.allPackageList = response.data;
          // console.log(this.selectHospital);
          this.packageList = response.data;
          // console.log(this.packageList);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    filterPackage() {
      let filterPackage = this.allPackageList.filter(
        (apackage) =>
          (
            apackage.packageName +
            " " +
            apackage.categoryName +
            " " +
            apackage.hospitalName +
            " " +
            apackage.packageDescription
          )
            .toLowerCase()
            .indexOf(this.searchPagkage.toLowerCase()) >= 0
      );
      this.packageList = filterPackage;
    },
    getNewToken() {
      if (this.channel == "plusV5") {
        let plusToken = this.$cookies.get("plus_access_token");
        this.getPlusDataV5(plusToken);
      } else {
        try {
          var refreshToken = this.$cookies.get("refresh_token");
          var token = new AmazonCognitoIdentity.CognitoRefreshToken({
            RefreshToken: refreshToken,
          });

          this.$store.state.userPool =
            new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
          // const cognitoUser = this.$store.state.userPool.getCurrentUser();

          const userData = {
            Username: this.$cookies.get("username"),
            Pool: this.$store.state.userPool,
          };

          const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

          cognitoUser.refreshSession(token, (err, session) => {
            if (err) {
              console.log(err);
              this.loadingStatus = false;
              this.error = err;
              window.$("#errorModal").modal("show");
            } else {
              this.accessToken = session.getIdToken().getJwtToken();
              this.$cookies.set("access_token", this.accessToken);
              this.$cookies.set(
                "refresh_token",
                session.getRefreshToken().getToken()
              );
              window.location.reload();
            }
          });
        } catch {
          this.error = "cannot get NewToken";
          window.$("#errorModal").modal("show");
        }
      }
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getDataHospital() {
      // this.alertSelectHospital=false
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {
            hospitalId: this.selectHospital,
          },
          {
            headers: {
              Authorization: "Bearer " + this.accessToken,
              "Accept-Language": this.lang,
            },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.packageHospital = res.data.recommendationPackage;
          // console.log("packageHospital", this.packageHospital);
          // customer
          // const customer = res.data.customer;
          // // riskScore
          // const riskScore = res.data.riskAssessment.risks;
          // // Riskrecommendationpack
          // const healthPackage = [];
          // for (let i = 0; i < riskScore.length; i++) {
          //   const recommended = riskScore[i]["recommendationPackage"];
          //   if (recommended != null && recommended.length > 0) {
          //     for (let j = 0; j < recommended.length; j++) {
          //       riskScore[i]["recommendationPackage"][j]["select"] =
          //         riskScore[i]["recommendationPackage"][j]["selected"] > 0;
          //     }
          //     healthPackage.push({
          //       categoryName: riskScore[i].riskName,
          //       severityName: riskScore[i].severityName,
          //       severity: riskScore[i].severity,
          //       maxSeverity: riskScore[i].maxSeverity,
          //       riskId: riskScore[i].riskId,
          //       statusShow: true,
          //       seeDetail: false,
          //       package: riskScore[i]["recommendationPackage"],
          //     });
          //   }
          // }
          // this.list = healthPackage;
          // for (let item of res.data.recommendationPackages) {
          //   item.select = item.selected > 0;
          // }
          // const data = this.groupBy(
          //   res.data.recommendationPackages,
          //   "categoryName"
          // );

          // for (const property in data) {
          //   this.list.push({
          //     categoryName: property,
          //     severityName: null,
          //     severity: null,
          //     riskId: null,
          //     maxSeverity: null,
          //     statusShow: true,
          //     seeDetail: false,
          //     package: data[property],
          //   });
          // }
          // this.packageHospital = this.list;
          // console.log(this.packageList);
          // // this.loadingStatus = false;
          // setTimeout(() => {
          //   this.loadingStatus = false;
          // }, 3000);
          // window.setTimeout(function () {
          //   window.$("#loadingModal").modal("hide");
          // }, 500);
        })
        .catch((error) => {
          if (error.response == null) {
            this.error = error;
          } else if (error.response.status == 403) {
            console.log("token expire");
            this.getNewToken();
            // RefreshToken
          } else {
            if (error.response.data.message) {
              this.error = error.response.data.message;
            } else {
              this.error = error;
            }
          }
          window.$("#errorModal").modal("show");
        });
    },
  },
});
</script>

<style lang="scss" scoped>
.bg-image-header {
  width: 39.6rem;
  // width:100%;
  // height: 28.6rem;
  height: 30rem;
  position: absolute;
  bottom: -3rem;
  right: 0rem;
  z-index: -9;
  object-fit: contain;

  @media only screen and (min-width: 614px) {
    right: 22vw;
  }

  @media only screen and (min-width: 1000px) {
    right: 30vw;
  }

  @media only screen and (max-width: 370px) {
    width: 35rem;
  }

  @media only screen and (max-width: 320px) {
    width: 32rem;
  }

  @media only screen and (max-width: 300px) {
    width: 29rem;
  }
}

.header {
  // font-family: "Libre Caslon Text", serif;
  position: relative;

  .coin-container {
    margin-top: 13rem;
    height: 5.5rem;
    position: relative;

    .value {
      height: 3.6rem;
      min-width: 17.5rem;
      width: 17.5rem;
      height: 3.6rem;
      border-radius: 3.6rem;
      background-color: #429928;

      .text {
        margin-left: 5.5rem;
        width: calc(100% - 5.4rem);
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        text-align: center;

        @media only screen and (min-width: 550px) {
          font-size: 23px;
        }
      }
    }

    .icon {
      width: 5.5rem;
      height: 5.5rem;
      border-radius: 5.5rem;
      // background-color: #fff;
      // box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
      position: absolute;
      top: 0;
      left: -3px;
    }
  }
}

.get-risk-container {
  // padding: 1rem;
  // width: calc(100% - 4rem);
  width: 95%;
  margin: 20px auto 26px;
  padding: 20px 20px 20px;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  border-radius: 20px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;

  .image {
    // background-color: red;
    height: 100%;
  }

  .content {
    width: 100%;
  }

  // @media only screen and (min-width: 714px) {
  //   grid-template-columns: auto auto;
  // }
}

.btn-take-test {
  width: 15rem;
  height: 3.3rem;
  border-radius: 3.3rem;
  color: #000;
  box-shadow: none;
  font-size: 1.6rem;
  background: #d2e97a;

  &:hover {
    background: #d2e97a;
  }
}

.see-all-link {
  text-decoration: underline;
  color: #037968;
  font-size: 14px;
  cursor: pointer;
}

.no-suggest-package {
  background: #fff;
  border-radius: 15px;
  width: calc(100%);
  max-width: calc(400px + 4rem);
  margin: 1.6rem auto;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  // height: 8rem;
  // font-size: 14px;
  // centering along main axis - X axis - Horizontal
  justify-content: center;
  // centering along cross axis - Y axis - Vertical
  align-items: center;

  // display: flex;
  .footer {
    height: 2.7rem;
    background: #f3f3e7;
    cursor: pointer;

    .rotate {
      transform: rotate(180deg);
    }
  }
}

.suggest-package {
  background: #fff;
  border-radius: 15px;
  width: calc(100% - 4rem);
  max-width: calc(400px + 4rem);
  margin: 1.6rem auto;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  overflow: hidden;
  position: relative;

  .risk-status {
    position: absolute;
    top: 0;
    right: 2rem;
    width: 7rem;
    height: 2.7rem;
    border-radius: 0 0 1rem 1rem;
    color: #fff;
    font-weight: 500;
    font-size: 1.2rem;
    text-transform: capitalize;
    text-align: center;
  }

  .risk-status.high {
    background-color: #e45757;
  }

  .risk-status.moderate {
    background-color: #e7c74e;
  }

  .risk-status.low {
    background-color: #6db557;
  }

  .body {
    position: relative;
    padding: 2rem 0rem 1rem;

    .blur-text {
      transition: 0.3s;
      position: absolute;
      z-index: 9;
      bottom: 1rem;
      height: 2rem;
      width: calc(100% - 1rem);
      background-image: linear-gradient(transparent, white);
    }

    .hidden-content {
      transition: 0.4s;
      display: grid;
      grid-template-columns: auto auto;
      overflow: hidden;
      min-height: 10rem;
      max-height: 10rem;

      .icon {
        // width: 10rem;
        width: fit-content;
        margin-right: 2rem;
        border-right: 2px solid #c8c8c8;

        .label {
          font-size: 14px;
          font-weight: 500;
          width: 10rem;
          margin: 1rem auto;
        }
      }
    }

    .suggest-note {
      // width: calc(100% - 1rem);
      // margin: 0.2rem 0;
      padding: 0rem 1rem 1rem 0;
      font-size: 1.1rem;
      color: #545454;
    }

    .hidden-des {
      // width: calc(100% - 1rem);
      margin: 0.2rem 0;
      padding: 0.6rem 1rem 1rem 0;
      font-size: 1.2rem;
      color: #545454;

      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 1rem;
    }
  }

  .footer {
    height: 2.7rem;
    background: #f3f3e7;
    cursor: pointer;

    span {
      transition: 0.4s;
      transform: rotate(0deg);
    }

    span.rotate {
      transform: rotate(180deg);
    }
  }
}

.suggest-package.show {
  overflow: auto;

  .hidden-content {
    min-height: 10rem;
    max-height: 100rem;
  }

  .body {
    .blur-text {
      opacity: 0;
    }
  }
}

.swiper-pagination-progressbar-active {
  background: #ffffff;
}

.swiper-pagination-progressbar {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  margin-top: 2rem;
}

.filterHospital {
  width: 100%;
  margin-top: 1rem;

  .hospital-input {
    border-radius: 2rem;
    align-items: center;
    margin-bottom: 1rem;
    width: 100%;

    .el-input__inner {
      font-size: 1.3rem;
      height: 3rem;
      border-radius: 1.5rem;
      // border: 0;
      // outline: 0;

      box-shadow: none;
      border: 1px solid #fff;
      background-color: #000;
      transition: 0.3s;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:focus {
        border: 1px solid #206b5e;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
      }
    }
  }
}
</style>
